import React from 'react'
import Card from '../../Reusable/Card'

const TextCard = ({ title, slug }: { title: string, slug: string }) => {
  return (
    <Card title={title}>
      <div className='flex justify-between mx-auto mt-4 pr-2'>
        <div className='font-medium text-xl'>{1}</div>
        <div className='font-medium text-2xl'>Rs.{1}</div>
      </div>
    </Card>
  )
}

export default TextCard
